export default __webpack_public_path__ + "static/media/508.b2218b5e.png";